export default [
    "16 16",
    '<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" fill="var(--ci-primary-color, currentColor)"/>\n' +
    '<rect x="0.5" y="0.5" width="15" height="15" rx="7.5" stroke="var(--ci-primary-color, currentColor)"/>\n' +
    '<path d="M11.3333 5.5L6.74999 10.0833L4.66666 8" stroke="white" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>'
]